import React from 'react';
import { Box, Skeleton } from '@mui/material';

const DashboardShellSkeleton = ({ sidebarWidth = 250 }) => {
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100vh' }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: sidebarWidth,
          bgcolor: 'var(--primary)',
          p: 2,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Skeleton variant="rectangular" height={40} width="100%" sx={{ borderRadius: 2 }} />
        <Skeleton variant="rectangular" height={2} width="100%" sx={{ opacity: 0.35 }} />
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={42} width="100%" sx={{ borderRadius: 2 }} />
        ))}
        <Box sx={{ flexGrow: 1 }} />
        <Skeleton variant="rectangular" height={44} width="70%" sx={{ borderRadius: 999 }} />
      </Box>

      {/* Main */}
      <Box sx={{ flexGrow: 1, p: 3, bgcolor: 'var(--secondary)' }}>
        <Skeleton variant="text" width="40%" height={42} />
        <Box sx={{ mt: 2, borderRadius: 3, overflow: 'hidden', bgcolor: '#fff' }}>
          <Box sx={{ p: 2 }}>
            <Skeleton variant="rectangular" height={52} />
          </Box>
          <Box sx={{ p: 2, pt: 0 }}>
            {Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} variant="rectangular" height={28} sx={{ mb: 1, borderRadius: 1.5 }} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardShellSkeleton;

